<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table :items="attachments" :headers="headers" hide-default-footer disable-pagination
          style="margin-bottom:200px">
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.orginal_file_name }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ dateTimeFormat(props.item.date_upload) }}</td>
              <td>{{ props.item.creator_user }}</td>
              <td>
                <v-icon small class="mr-2" @click="downloadAttachment(props.item.fingerprint)"
                  title="Pobierz załącznik">fa-download</v-icon>
                <v-icon small class="mr-2" @click="deleteAttachment(props.item.fingerprint)"
                  v-if="$can('do', 'POKO_Klienci_Zalaczniki_Usuwanie')" title="Usuń załącznik">fa-trash-alt</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="$can('do', 'POKO_Klienci_Zalaczniki_Dodawanie')">
      <v-col cols="3">
        <v-file-input v-model="file" label="Nowy załącznik" placeholder="Wybierz plik..."
          prepend-icon="fa-paperclip"></v-file-input>
      </v-col>
      <v-col cols="2">
        <v-select v-model="description" label="Opis załącznika" placeholder="Wybierz opis załącznika"
          :items="descriptions" item-text="description" return-object></v-select>
      </v-col>
      <v-col cols="2" v-if="description && description.type == 8">
        <v-select v-model="typ_umowy" label="Typ umowy kredytowej" placeholder="Wybierz typ umowy kredytowej"
          :items="podstawy_kredytu"></v-select>
      </v-col>
      <v-col cols="2" v-if="showInny || typ_umowy == 'Inne'">
        <v-text-field v-model="diffrent_description" label="Własny opis"
          placeholder="Wprowadź własny opis"></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-btn color="primary" style="margin-top:10px" @click="UploadFile">Dodaj załącznik</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import swal from "sweetalert";
import { clientService } from "@/services";
import dayjs from "dayjs";
import { roomService } from "@/components/admin/rooms/Rooms";
import { mapActions } from "vuex";

export default {
  name: "ClientAttachments",
  props: ["client"],
  data() {
    return {
      file: null,
      attachments: [],
      description: null,
      descriptions: [],
      typ_umowy: '',
      podstawy_kredytu: ['Umowa podmiot prywatny', 'Umowa podmiot publiczny', 'Umowa fundacja', 'Umowa ubezpieczyciel', 'Decyzja dyrekcji', 'Inne'],
      showInny: false,
      diffrent_description: '',
      headers: [
        { text: 'Nazwa pliku', align: 'left', value: 'orginal_file_name' },
        { text: 'Opis', align: 'left', value: 'description' },
        { text: 'Data', align: 'left', value: 'date_upload' },
        { text: 'Kto dodał', align: 'left', value: 'creator_user' },
        { text: 'Akcje', sortable: false, align: 'left', value: 'fingerprint' }
      ],
    }

  },
  methods: {
    ...mapActions("alert", ["error", "success"]),
    fileDownload(data, filename, mime) {
      var blob = new Blob([data], { type: mime || 'application/octet-stream' });
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        window.navigator.msSaveBlob(blob, filename);
      }
      else {
        var blobURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename);

        if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
        }

        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
      }
    },
    downloadAttachment(fingerprint) {
      clientService.preDownloadAttachment(fingerprint).then((response) => {
        let pokoFile = response.data.result
        clientService.downloadAttachment(pokoFile.token).then((resp) => {
          if (resp.data != null) {
            this.fileDownload(resp.data, pokoFile.file_name, pokoFile.mime_type)
          }
          else {
            throw 'error'
          }
        }).catch(() => {
          this.showError('Błąd pobierania załącznika')
        })
      }).catch(() => {
        this.showError('Błąd pobierania załącznika')
      })
    },
    deleteAttachment(fingerprint) {
      swal({
        title: "Czy na pewno?",
        text:
          "Czy na pewno chcesz usunąć ten załącznik?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          clientService.deleteAttachment(fingerprint)
            .then(() => {
              this.success("Usunięto");
              this.getAttachments()
            }).catch(() => {
              this.showError("Nie można usunąć załącznika");
            });
        }
      });
    },
    getDescriptions() {
      clientService.getFileDescriptions().then((resp) => {
        let descr = resp.data.result
        descr.push({ description: 'Inny', type: 0 });
        this.descriptions = descr
      }).catch(() => {
        this.showError('Błąd pobierania typów załączników')
      })
    },
    dateTimeFormat(val) {
      if (val) {
        return dayjs(val).format('DD-MM-YYYY HH:mm')
      }
      return ''
    },
    UploadFile() {
      if (!this.description) {
        this.showError('Nie wybrano opisu załącznika')
        return
      }
      if (this.description && this.description.description == 'Inny' && !this.diffrent_description) {
        this.showError('Proszę podać własny opis.')
        return
      }
      if (this.description.type == 8 && (!this.typ_umowy || this.typ_umowy == '')) {
        this.showError('Proszę wybrać typ umowy kredytowej.')
        return
      }
      if (this.typ_umowy == 'Inne' && !this.diffrent_description) {
        this.showError('Proszę podać inny opis umowy kredytowej')
        return
      }
      if (this.file) {
        let descr = this.description.description
        if (this.description == 'Inny')
          descr = this.diffrent_description

        if (this.description.type == 8) {
          descr = this.description.description + ": " + this.typ_umowy
          if (this.typ_umowy == 'Inne')
            descr = this.description.description + ": " + this.diffrent_description
        }

        let formData = new FormData()
        formData.append('file', this.file);
        formData.append('ClientId', this.client)
        formData.append('description', descr)
        formData.append('type', this.description.type)
        clientService.uploadAttachment(formData).then(() => {
          this.getAttachments()
        }).catch(error => {
          let err = error.response
          if (err.data != null && err.data.error && err.data.error.message) {
            this.showError(err.data.error.message)
          }
          else {
            this.showError("Nie można wgrać pliku")
          }
        })
      }
      else {
        this.showError('Nie wybrano pliku')
      }
    },
    getAttachments() {
      clientService.GetAttachments(this.client).then((resp) => {
        this.attachments = resp.data.result
      }).catch(() => {
        this.showError('Nie można pobrać listy załączników')
      })
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
      });
    }
  },
  watch:
  {
    description: function (newDescription) {
      if (newDescription && newDescription.description == 'Inny')
        this.showInny = true
      else
        this.showInny = false
    }
  },
  mounted() {
    this.getAttachments()
    this.getDescriptions()
  }
}
</script>

<style scoped></style>